import {Component} from 'preact';
import style from './style.module.scss';
import ErrorMessage from '../errorMessage';
import {loyaltyDataService} from '../../services/loyaltyDataService';
import {i18nService} from "../../services/i18nService";

export default class CouponControls extends Component {

  constructor(props) {
    super(props);
    this.state = {
      partnerUrl: false,
      showLoadIndicator: false,
    };

    this._consumePartnerCoupon = this._consumePartnerCoupon.bind(this);
  }

  async componentDidMount() {
    if (this.props && this.props.coupon && this.props.coupon.externalCode &&
      this.props.coupon.externalCode.startsWith('pa_')) {
      try {
        const response = await loyaltyDataService.checkPartnerPromotion(this.props.coupon.externalCode);
        if (response && response.code) {
          this.setState({partnerUrl: response.code});
        }
      } catch (_) {
      }
    }
  }

  render(props, state) {
    let coupon = props.coupon;
    if (coupon.externalCode &&
      coupon.externalCode.startsWith('pa_')) {
      return (
        <div className={style['coupon-controls']}>
          <div className={style.center}>
            {!this.state.partnerUrl &&
              <ny-button
                buttonType={'standard-width-button'}
                actionType={'primary'}
                isLoading={this.state.showLoadIndicator}
                onClick={() => {
                  // noinspection JSIgnoredPromiseFromCall
                  this._consumePartnerCoupon(coupon.externalCode);
                }}
              >
                <span slot={'buttonLabel'}>{i18nService.translate('partnercoupon_activate_text')}</span>
              </ny-button>
            }
            {this.state.partnerUrl &&
              <ny-button
                buttonType={'standard-width-button'}
                actionType={'primary'}
                onClick={() => window.open(this.state.partnerUrl, '_blank')}
              >
                <span slot={'buttonLabel'}>{i18nService.translate('partnercoupon_link_to_partner')}</span>
              </ny-button>
            }
          </div>

          {this.state.showError &&
            <div className={style["error-wrapper"]}>
              <ErrorMessage message={i18nService.translate('error_message_partnercoupon_depleted')}/>
            </div>
          }
        </div>
      );
    } else {
      return (
        <div className={style['coupon-controls']}>
          <div className={style.center}>
            <a href={'https://www.newyorker.de/app/'}>
              <ny-button buttonType={'standard-width-button'} actionType={'primary'}>
                <span slot={'buttonLabel'}>{i18nService.translate('partnercoupon_activate_in_app_text')}</span>
              </ny-button>
            </a>
          </div>
        </div>
      );
    }
  }

  async _consumePartnerCoupon(externalId) {
    this.setState({showLoadIndicator: true, showError: false});
    try {
      const result = await loyaltyDataService.consumePartnerPromotion(externalId);
      if (result.code) {
        this.setState({
          partnerUrl: result.code,
          showLoadIndicator: false,
        });
      }
    } catch (e) {
      this.setState({
        showLoadIndicator: false,
        showError: true,
      });
    }
  }
}
